<template>
    <div>
        <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
        <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
            <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una estatus de incidencia</option>
            <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Estatus de Incidencias</option>
            <option v-for="TipoEstatus in TiposEstatusIncidencias" :value="TipoEstatus.TipoEstatusIncidenciaId">{{TipoEstatus.Nombre}}</option>        
        </select>      
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposEstatusIncidencias: [],
        idDelModelo: null        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      //this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_SIAP_Catalogo_Establecer032TipoEstatusIncidencias", params);
    },
    methods: {
        cargarCatalogoEstatusIncidencias: function(){
            if(this.parametros == null || this.parametros == undefined)
            this.parametros = {}
            this.parametros.EsPrueba = this.enumeraciones.EsPrueba

            axios.post(api.conexion + api.SIAP.catalogos.C032TipoEstatusIncidencia, this.parametros)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                this.TiposEstatusIncidencias = respuesta.data.GetTiposEstatusIncidencias;
                
                if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                    this.TiposEstatusIncidencias = respuesta.data.GetTiposEstatusIncidencias.filter(cond => this.parametros.filtros.some(incidencia => incidencia == cond.TipoIncidenciaId));
                }
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
            });
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const params = {
            llave: this.idDelInput,
            valor: evento.target.value
            }
            
            this.$store.dispatch("A_SIAP_Catalogo_Establecer032TipoEstatusIncidencias", params);
            this.$emit("valorParaElPadre", evento);        
        }
    },
    created() {
      this.cargarCatalogoEstatusIncidencias();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Comun/Catalogos/032TipoEstatusIncidencia.vue